import { Form, Input, Row, Col, Switch, Select } from 'antd';
import { useEffect, useRef, useState } from 'react';
import WebEditUniversal, { WebEditUniversalProps } from '../../system/WebEditUniversal';
import getList from '../../../utilsTsx/universal/getList';
import arrayHandle from '../../../utilsTs/baseLib/arrayHandle';
import fetchApi from '../../../utilsTsx/components/system/fetchApi';
import { getService } from '../../system/WebUniversal';

const SmsServiceEdit = (props: any) => {
    const apiId = 'smsService';
    const [form] = Form.useForm();
    const { defaultService } = props;
    const ref = useRef<any>(undefined);

    const [smsProviderData, setSmsProviderData] = useState<any>();
    const [otherSystemAccountData, setOtherSystemAccountData] = useState<any>();
    const [smsInscriptionModeData, setSmsInscriptionModeData] = useState<any>();
    const [querySmsTemplateListData, setQuerySmsTemplateListData] = useState<any>();
    const [templateContent, setTemplateContent] = useState<string | undefined>(undefined);
    const [isTemplateContentRequired, setIsTemplateContentRequired] = useState<boolean>(false);

    /**
     * 获取模版内容
     * @param templateCode 模板代码
     */
    const getTemplateContent = (arr: Array<any>, templateCode: string) => {
        const findValueRes = arrayHandle.findValue(arr, templateCode, {
            keyIdName: 'templateCode'
        })
        if (findValueRes.success === true) {
            const [findData] = findValueRes.data;
            const findTemplateContent = findData?.templateContent;
            setTemplateContent(findTemplateContent ?
                `===> ${findTemplateContent}` :
                undefined);
            if (findTemplateContent !== form.getFieldValue('templateContent')) {
                form.setFieldValue('templateContent', findTemplateContent);
            }
        }
    };

    /**
     * 获取模版列表
     * @param urlService 
     * @param otherSystemAccountId
     * @param templateCode
     */
    const getSmsTemplateList = (urlService: string, otherSystemAccountId: string, templateCode?: string) => {
        fetchApi.GET(urlService,
            {
                query: {
                    apiId: 'smsService',
                    apiExtend: 'querySmsTemplateList',
                    apiData: {
                        otherSystemAccountId
                    }
                }
            }).then(res => {
                if (res.success === true) {
                    setQuerySmsTemplateListData(res.data);
                    if (templateCode) {
                        getTemplateContent(res.data, templateCode);
                    }
                } else {
                    setQuerySmsTemplateListData([]);
                    form.setFieldValue('templateContent', '');
                }
            })
    };

    /**
     * 刷新模版列表
     */
    const refreshSmsTemplateList = () => {
        const smsProviderId = form.getFieldValue('smsProviderId');
        const templateCode = form.getFieldValue('templateCode');
        if (smsProviderId === 2) {
            const otherSystemAccountId = form.getFieldValue('otherSystemAccountId');
            getSmsTemplateList(defaultService, otherSystemAccountId, templateCode);
            setIsTemplateContentRequired(true);
        } else {
            setQuerySmsTemplateListData([]);
            setIsTemplateContentRequired(false);
            form.setFieldValue('templateContent', '');
        }
    };

    useEffect(() => {
        if (ref.current) {
            ref.current.getRow?.then((resData: any) => {
                if (resData.success === true)
                    if (resData?.data?.smsProviderId === 2) {
                        getSmsTemplateList(defaultService, resData?.data?.otherSystemAccountId, resData?.data?.templateCode);
                    }
            })
        }
        const fetchData = async () => {
            fetchApi.GET(defaultService,
                {
                    query: {
                        apiId: 'generalData',
                        apiVariable: 'smsProvider@smsInscriptionMode',
                        apiExtend: 'showLists'
                    }
                }).then(res => {
                    if (res.success === true) {
                        const { smsProvider, smsInscriptionMode } = res.data;
                        setSmsProviderData(smsProvider);
                        setSmsInscriptionModeData(smsInscriptionMode);
                    }
                })
            fetchApi.GET(getService('bm'),
                {
                    query: {
                        apiId: 'otherSystemAccount',
                        apiExtend: 'showList'
                    }
                }).then(res => {
                    if (res.success === true) {
                        setOtherSystemAccountData(res.data);
                    }
                })
        }
        fetchData();
    }, []);

    const extendProps: WebEditUniversalProps = {
        ...props,
        form,
        apiId: 'smsService',
        serviceId: 'business',
        formOptions: {
            instance: form,
            children: (<Row gutter={[8, 0]}>
                <Col span={10}>
                    <Form.Item
                        label="id"
                        name="id">
                        <Input disabled={true}
                        />
                    </Form.Item>
                </Col>

                <Col span={14}>
                    <Form.Item
                        label="名称"
                        name="serviceName"
                        rules={[{ required: true, message: '短信服务名称!' }]}>
                        <Input />
                    </Form.Item>
                </Col>

                <Col span={8}>
                    <Form.Item
                        label="服务商"
                        name="smsProviderId"
                        rules={[{ required: true, message: '短信服务商!' }]}>
                        <Select
                            placeholder="短信服务商"
                            onChange={refreshSmsTemplateList}
                            showSearch={{
                                optionFilterProp: 'label',
                                filterOption: (input, option: any) =>
                                    option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
                            }}
                            options={getList.general2(smsProviderData)} />
                    </Form.Item>
                </Col>

                <Col span={9}>
                    <Form.Item
                        label="落款"
                        name="inscription"
                        tooltip='落款或签名'
                        rules={[{ required: true, message: '落款或签名!' }]}>
                        <Input />
                    </Form.Item>
                </Col>

                <Col span={7}>
                    <Form.Item
                        label="模式"
                        name="inscriptionModeId"
                        tooltip='落款模式，无(NULL)：内容；【前置】：[落款]内容；【后置】：内容[落款]'
                    >
                        <Select
                            placeholder="落款模式"
                            showSearch={{
                                optionFilterProp: 'label',
                                filterOption: (input, option: any) =>
                                    option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
                            }}
                            options={getList.general2(smsInscriptionModeData)} />
                    </Form.Item>
                </Col>

                <Col span={12}>
                    <Form.Item
                        label="帐号"
                        name="otherSystemAccountId"
                        rules={[{ required: true, message: '帐号!' }]}>
                        <Select
                            placeholder="帐号"
                            onChange={refreshSmsTemplateList}
                            showSearch={{
                                optionFilterProp: 'label',
                                filterOption: (input, option: any) =>
                                    option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
                            }}
                            options={getList.general2(otherSystemAccountData, { itemName: 'accountName' })} />
                    </Form.Item>
                </Col>

                <Col span={12}>
                    <Form.Item
                        label="模版"
                        tooltip={`阿里云短信模版${templateContent ? templateContent : ''}`}
                        name="templateCode"
                        rules={[{ required: isTemplateContentRequired, message: '阿里云短信模版!' }]}>
                        <Select
                            placeholder="阿里云短信模版"
                            onChange={(_e, row: any) => {
                                const { item } = row;
                                setTemplateContent(item?.templateContent ?
                                    `===> ${item?.templateContent}` :
                                    undefined);
                                form.setFieldValue('templateContent', item?.templateContent);
                            }}
                            showSearch={{
                                optionFilterProp: 'label',
                                filterOption: (input, option: any) =>
                                    option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
                            }}
                            options={getList.general2(querySmsTemplateListData, {
                                itemId: 'templateCode',
                                itemName: 'templateName',
                                includeNull: true
                            })} />
                    </Form.Item>
                </Col>

                <Col span={24}>
                    <Form.Item
                        label="模版内容"
                        name="templateContent"
                        tooltip='阿里云短信模版内容，请跟随阿里云更新'>
                        <Input.TextArea
                            placeholder="阿里云短信模版内容"
                            rows={8}>
                        </Input.TextArea>
                    </Form.Item>
                </Col>

                <Col span={4}>
                    <Form.Item
                        label="复核"
                        name="isRecheckDeliveryStatus"
                        tooltip='复核发送状态'
                        valuePropName="checked"
                        initialValue={true}>
                        < Switch checked={true}
                            checkedChildren="是"
                            unCheckedChildren="否" />
                    </Form.Item>
                </Col>

                <Col span={4}>
                    <Form.Item
                        label="状态"
                        name="isUse"
                        valuePropName="checked"
                        initialValue={true}>
                        < Switch checked={true}
                            checkedChildren="启用"
                            unCheckedChildren="关闭" />
                    </Form.Item>
                </Col>

            </Row>)
        }
    };

    return (<WebEditUniversal ref={ref} {...extendProps} />)
}

export default SmsServiceEdit;